<template>
  <section id="Deltagerliste" class="section" v-if="!this.$root.loading">
    <div class="section-header js-section-header">
      <h2>Deltagere</h2>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <ul class="responsive-table">
                <li class="table-header">
                  <div class="column column-5">Holdnavn</div>
                  <div class="column column-5">Deltager #1</div>
                  <div class="column column-5">Deltager #2</div>
                  <div class="column column-2 text-right">
                    <span class="badge badge-light">{{$root.registrations.total}}</span>
                  </div>
                </li>
                <participantGroup v-if="!isRouteDisabled('Kort')" :route="$root.registrations.short.men" name="short.men" zIndex="80" />
                <participantGroup v-if="!isRouteDisabled('Kort')" :route="$root.registrations.short.women" name="short.women" zIndex="81" />
                <participantGroup v-if="!isRouteDisabled('Kort')" :route="$root.registrations.short.mix" name="short.mix" zIndex="82" />
                <participantGroup v-if="!isRouteDisabled('Lang')" :route="$root.registrations.long.men" name="long.men" zIndex="83" />
                <participantGroup v-if="!isRouteDisabled('Lang')" :route="$root.registrations.long.women" name="long.women" zIndex="84" />
                <participantGroup v-if="!isRouteDisabled('Lang')" :route="$root.registrations.long.mix" name="long.mix" zIndex="85" />
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import participantGroup from "@/components/partials/participantGroup";

export default {
  name: "PARTICIPANTS",
  components: {
    participantGroup
  },
  methods:{
    isRouteDisabled: function(route){
      const key = route === 'Kort' ? 'short' : 'long';
      return !this.$root.eventData.routes[key].active;
    }
  }
};
</script>
<style lang="scss" scoped>
.section {
  background-image: linear-gradient(#d8f2dc, #c5ebcb);
}
</style>